module.exports = __webpack_public_path__ + "static/media/plicometria1.cfdff1f3.jpg";